export const Config = {
  API_URL: 'https://api.darwinlog.com/v1/api/darwinlog',
  // API_URL: 'http://192.168.31.133:8084/v1/api/darwinlog',
  // API_TEST: 'http://192.168.31.133:8084/v1/api/darwinlog',
}